import { render, staticRenderFns } from "./production.vue?vue&type=template&id=54bfaba4&scoped=true&"
import script from "./production.vue?vue&type=script&lang=ts&"
export * from "./production.vue?vue&type=script&lang=ts&"
import style0 from "./production.vue?vue&type=style&index=0&id=54bfaba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bfaba4",
  null
  
)

export default component.exports